module.exports = __webpack_public_path__ + "img/government-right-4.ef20cc93.png";